<div class="body_container text-grey">
  <app-component-navigation></app-component-navigation>
  <div class="row h-97 w-100 ms-1">
    <div class="w-100 d-flex flex-column h-100 p-0">
      <div class="topPanel marginForLogs d-none">
        <h2 class="mainHeading">Monitor Nodes -</h2>
        <h4><span class="bi bi-layers"></span> {{ depName }}</h4>
        <button
          type="button"
          class="default-btn"
          title="Refresh Details"
          (click)="refreshComponent()"
        >
          <span class="bi bi-arrow-clockwise"></span>
          Refresh
        </button>
      </div>
      <div class="flex-grow-1 h-95">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
